/**
 * This value is read by the MNTN script that is located in GTM (Google Tag Manager).
 * This value is also submitted to Marketo to be able to pull out conversion data for our website visitors.
 *
 * @param data {Data}
 */
module.exports = function thenGenerateUserUuid(data) {
  const ITERABLE_MNTN_UUID = "iterable_mntn_uuid";

  let userUuid = data.window.localStorage.getItem(ITERABLE_MNTN_UUID);

  if (!userUuid) {
    if (window.crypto && window.crypto.randomUUID) {
      userUuid = window.crypto.randomUUID();
    }

    data.window.localStorage.setItem(ITERABLE_MNTN_UUID, userUuid);
    userUuid = data.window.localStorage.getItem(ITERABLE_MNTN_UUID);
  }

  data.userUuid = userUuid;
};
